// src/components/layouts/TopBar/StyledNavItem.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import React from 'react';
import styled from '@emotion/styled';
import { GRAY_SCALE, MEDIA_QUERIES } from 'constants/ThemeConstant';
import { baseTheme, rgba } from 'configs/appEngine';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// STYLED COMPONENTS
// *******************************************************************************
const ItemWrapper = styled('div')(({ mode }) => ({
  display: 'flex',
  alignItems: 'center',
  lineHeight: 1.5,
  cursor: 'pointer',
  padding: '0 1rem',
  color: mode === 'dark' ? GRAY_SCALE.GRAY : rgba(GRAY_SCALE.WHITE, 0.85),
  [`@media ${MEDIA_QUERIES.MOBILE}`]: {
    padding: '0 0.75rem',
  },
  '.ant-badge': {
    color: mode === 'dark' ? GRAY_SCALE.GRAY : rgba(GRAY_SCALE.WHITE, 0.85),
  },
  '.nav-icon': {
    fontSize: '1.25rem',
  },
  '&:hover, &.ant-dropdown-open, &.ant-popover-open': {
    '> *': {
      color: mode === 'dark' ? baseTheme.colorPrimary : GRAY_SCALE.WHITE,
    },
    '.profile-text': {
      color: mode === 'dark' ? GRAY_SCALE.GRAY : GRAY_SCALE.WHITE,
    },
  },
}));

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const StyledNavItem = ({ children, ...props }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. EFFECTS II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <ItemWrapper {...props}>{children}</ItemWrapper>;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default StyledNavItem;

// *******************************************************************************
// HELPERS
// *******************************************************************************
